<!--
 * @Description: 
 * @FilePath: \haiwai_zb_pc\src\views\Login.vue
 * @Version: 1.0
 * @Autor: CuiGang
 * @Date: 2021-01-21 19:23:15
 * @LastEditors: CuiGang
 * @LastEditTime: 2021-02-03 13:38:09
-->
<template>
  <div class="mask_page">
    <div class="centerL" @keydown.enter="handleLogin">
      <img
        src="../assets/dialog_close.png"
        alt=""
        class="close"
        @click="close"
      />
      <div class="top">{{ $t("login.loginTitle") }}</div>
      <div class="undone">
        <div style="margin: 20px"></div>
        <el-form
          :label-position="labelPosition"
          label-width="0px"
          :rules="rules"
          ref="form"
          :model="form"
          status-icon
        >
          <el-form-item label="" prop="email" class="iconNewYes">
            <el-input
              type="email"
              autocomplete="off"
              :placeholder="$t('login.email')"
              v-model="form.email"
            />
          </el-form-item>
          <el-form-item label="" prop="pwd" class="pass">
            <el-input
              type="password"
              autocomplete="off"
              :placeholder="$t('login.pwd')"
              v-model="form.pwd"
              show-password
            />
          </el-form-item>

          <!-- 验证码 -->
          <!-- <el-form-item label="" prop="code" class="pass identifyinput">
            <el-input
              type="code"
              autocomplete="off"
              placeholder="请输入验证码"
              v-model="form.code"
            />
          </el-form-item>
          <el-form-item>
            <div class="identifybox">
              <div>
                <svg  v-if="codeimgLoadding" t="1611826084887" class="loadingicon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3037" width="32" height="32"><path d="M512 337.322667a26.666667 26.666667 0 0 1-26.666667-26.666667V197.333333a26.666667 26.666667 0 1 1 53.333334 0v113.322667c0 14.762667-11.946667 26.666667-26.666667 26.666667z" fill="#000000" p-id="3038"></path><path d="M424.661333 360.746667a26.666667 26.666667 0 0 1-36.394666-9.728l-56.661334-98.133334a26.666667 26.666667 0 0 1 46.122667-26.666666l56.661333 98.133333a26.624 26.624 0 0 1-9.728 36.394667z" fill="#000000" opacity=".9" p-id="3039"></path><path d="M360.746667 424.661333a26.624 26.624 0 0 1-36.394667 9.728l-98.133333-56.661333a26.624 26.624 0 1 1 26.666666-46.122667l98.133334 56.661334c12.714667 7.338667 17.066667 23.68 9.728 36.394666z" fill="#000000" opacity=".85" p-id="3040"></path><path d="M337.322667 512c0 14.72-11.946667 26.666667-26.666667 26.666667H197.333333a26.666667 26.666667 0 1 1 0-53.333334h113.322667c14.762667 0 26.666667 11.946667 26.666667 26.666667z" fill="#000000" opacity=".8" p-id="3041"></path><path d="M360.746667 599.338667a26.666667 26.666667 0 0 1-9.728 36.394666l-98.133334 56.661334a26.666667 26.666667 0 0 1-26.666666-46.122667l98.133333-56.661333a26.624 26.624 0 0 1 36.394667 9.728z" fill="#000000" opacity=".75" p-id="3042"></path><path d="M424.661333 663.253333a26.624 26.624 0 0 1 9.728 36.394667l-56.661333 98.133333a26.624 26.624 0 1 1-46.122667-26.666666l56.661334-98.133334a26.666667 26.666667 0 0 1 36.394666-9.728z" fill="#000000" opacity=".7" p-id="3043"></path><path d="M512 686.677333c14.72 0 26.666667 11.946667 26.666667 26.666667v113.322667a26.666667 26.666667 0 1 1-53.333334 0v-113.322667c0-14.762667 11.946667-26.666667 26.666667-26.666667z" fill="#000000" opacity=".65" p-id="3044"></path><path d="M599.338667 663.253333a26.666667 26.666667 0 0 1 36.394666 9.728l56.661334 98.133334a26.666667 26.666667 0 0 1-46.122667 26.666666l-56.661333-98.133333a26.624 26.624 0 0 1 9.728-36.394667z" fill="#000000" opacity=".6" p-id="3045"></path><path d="M663.253333 599.338667a26.624 26.624 0 0 1 36.394667-9.728l98.133333 56.661333a26.624 26.624 0 1 1-26.666666 46.122667l-98.133334-56.661334a26.666667 26.666667 0 0 1-9.728-36.394666z" fill="#000000" opacity=".55" p-id="3046"></path><path d="M686.677333 512c0-14.72 11.946667-26.666667 26.666667-26.666667h113.322667a26.666667 26.666667 0 1 1 0 53.333334h-113.322667a26.666667 26.666667 0 0 1-26.666667-26.666667z" fill="#000000" opacity=".5" p-id="3047"></path><path d="M663.253333 424.661333a26.666667 26.666667 0 0 1 9.728-36.394666l98.133334-56.661334a26.666667 26.666667 0 0 1 26.666666 46.122667l-98.133333 56.661333a26.624 26.624 0 0 1-36.394667-9.728z" fill="#000000" opacity=".4" p-id="3048"></path><path d="M599.338667 360.746667a26.624 26.624 0 0 1-9.728-36.394667l56.661333-98.133333a26.624 26.624 0 1 1 46.122667 26.666666l-56.661334 98.133334a26.666667 26.666667 0 0 1-36.394666 9.728z" fill="#000000" opacity=".3" p-id="3049"></path></svg>
                <img :src="srcUrl" alt="随机验证码图" @load="codeimgLoadding = false">
              </div>
              <el-button @click="refreshCode" type='text' class="textbtn">看不清，换一张</el-button>
            </div>
          </el-form-item> -->

          <el-form-item class="reset_pwd">
            <span>{{ $t("login.forgetPwd") }}</span>
            <span
              class="s2"
              @click="$emit('toggle-dialog', { dialogType: 3, show: true })"
              >{{ $t("login.findPwd") }}</span
            >
          </el-form-item>
          <el-form-item>
            <el-button
              :class="['zhuce', { unready: !emailReady || !pwdReady }]"
              type="primary"
              @click="handleLogin"
              >{{ $t("signIn") }}</el-button
            >
          </el-form-item>
        </el-form>
        <div class="login_rightnow">
          {{ $t("login.noAccount") }}
          <span
            class="login"
            @click="$emit('toggle-dialog', { dialogType: 2, show: true })"
            >{{ $t("login.signUpNow") }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  issbccase,
  testTSZF,
  testSpace,
  testEmail,
  testPWD
} from "../plugins/util";
import { loginApi, refreshCodeApi } from "@/api/home";
import { setCookie } from "@/plugins/cookie";
export default {
  name: "login",
  data() {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('login.emailEmpty')));
        this.emailReady = false;
      }
      setTimeout(() => {
        if (!testEmail(value)) {
          this.emailReady = false;
          return callback(new Error(this.$t('login.emailErr')));
        } else {
          this.emailReady = true;
          callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        this.pwdReady = false;
        callback(new Error(this.$t('login.pwdEmpty')));
      } else if (!testPWD(value)) {
        this.pwdReady = false;
        callback(new Error(this.$t('login.pwdErr')));
      } else if (testTSZF(value)) {
        this.pwdReady = false;
        return callback(new Error(this.$t("login.pwdSpecialWordErr")));
      } else if (issbccase(value)) {
        this.pwdReady = false;
        return callback(new Error(this.$t("login.pwdFullWidthErr")));
      } else if (testSpace(value)) {
        this.pwdReady = false;
        return callback(new Error(this.$t("login.pwdSpacesErr")));
      } else {
        this.pwdReady = true;
        callback();
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value && value.length == 4) {
        this.codeReady = true;
      } else {
        this.codeReady = false;
        callback(new Error(this.$t('login.codeErr')));
      }
    };
    return {
      codeimgLoadding: true,
      ajaxing: false,
      labelPosition: "left",
      emailReady: false,
      pwdReady: false,
      codeReady: false,
      form: {
        email: "",
        pwd: ""
        // key:"",
        // code:"",
      },
      rules: {
        email: [{ validator: checkEmail, trigger: "change" }],
        pwd: [{ validator: validatePass, trigger: "change" }]
        // code: [{ validator: checkCode, trigger: "change" }],
      },
      timeStamp: "",
      srcUrl: ""
    };
  },
  mounted() {
    // this.refreshCode();
  },
  methods: {
    async handleLogin() {
      if (this.ajaxing) return;
      let _this = this;

      if (this.emailReady && this.pwdReady) {
        // && this.codeReady
        this.ajaxing = true;

        let res = await this.$axios({
          url: loginApi,
          method: "post",
          data: _this.form
        });
        res = res.data;
        if (res.status == 0) {
          // TODO:需要下放用户信息
          window.sessionStorage.setItem("token", res.data.token);
          window.sessionStorage.setItem(
            "userInfo",
            JSON.stringify({
              name: res.data.name,
              id: res.data.userId
            })
          );
          window.sessionStorage.setItem("settlementCurrency", res.data.settlementCurrency);
          // 登录过期设置
          window.sessionStorage.setItem(
            "expire",
            new Date().getTime() + 1000 * 60 * 60
          );

          this.$message.success(this.$t("login.signInSuc"));
          window.setTimeout(() => {
            if (_this.$route.path.includes("/fy")) {
              _this.close();
            } else {
              window.location.reload();
            }
          }, 2000);
          // this.$router.back();
        } else if (res.status == 302) {
          // 登录重定向
          this.$message.success(this.$t("login.redirectToAdmin"));
          window.sessionStorage.clear();
          window.localStorage.clear();
          window.setTimeout(() => {
            window.location.href = res.data;
          }, 1000);
        } else {
          this.$message.error(
            res.message ? res.message : `${this.$t("login.signInFail")}, Code: ${res.status}`
          );
        }
        this.ajaxing = false;
      }
    },
    close() {
      this.$emit("toggle-dialog", { dialogType: 1, show: false });
    },
    refreshCode() {
      this.timeStamp = new Date().getTime();
      this.srcUrl = refreshCodeApi + "?key=" + this.timeStamp;
      this.form.key = this.timeStamp;
    }
  }
};
</script>

<style lang="less">
.loadingicon {
  height: 100%;
  margin-left: 80px;
}
.identifybox {
  padding: 0px 50px;
  display: flex;
  justify-content: space-between;
  img {
    width: 200px;
    height: 75px;
  }
}
.iconstyle {
  color: #409eff;
}
.mask_page {
  overflow: auto;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9;
  .centerL {
    width: 380px;
    // height: 691px;
    margin: 140px auto 0;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
    background: #ffffff;
    position: relative;
    padding-bottom: 7px;
    .top {
      width: 380px;
      height: 66px;
      background: #1077ff;
      background: url(../assets/login/mask_banner.png) no-repeat center;
      background-size: 100% 100%;
      font-size: 15px;
      font-weight: bold;
      color: #ffffff;
      line-height: 66px;
      text-align: center;
    }

    .close {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 22px;
      top: 25px;
      cursor: pointer;
    }
    .undone {
      .iconNewYes {
        .el-icon-circle-check {
          background: url(../assets/login/yes.png) center no-repeat;
          background-size: cover;
        }
        .el-icon-circle-check:before {
          content: "";
          font-size: 16px;
          visibility: hidden;
        }
        .el-icon-circle-close {
          background: transparent;
          background-size: cover;
        }
        .el-icon-circle-close:before {
          content: "";
          font-size: 16px;
          visibility: hidden;
        }
        .el-input__icon {
          line-height: 21px;
        }
      }
      text-align: center;
      .el-form-item {
        margin-bottom: 18px;
      }
      .el-input__inner {
        width: 304px;
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #8a8e96;
        line-height: 19px;
        border: none;
        border-bottom: 1px solid rgba(234, 235, 236, 1);
        &::placeholder {
          font-size: 13px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #8a8e96;
          line-height: 19px;
        }
      }
      .el-input__suffix {
        right: 40px;
      }
      .el-input__icon {
        width: 21px;
        height: 21px;
      }
      .pass {
        .el-input__suffix {
          padding-top: 7px;
        }
        .el-icon-view {
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACuUlEQVRYR+2WTUgUYRjH/8+7ibnSJuTJToXQBx2i8FAZ1WUjIiuErUuUYszuVriz7M41oUvsbM6KtMNE6aVDilBRlHbJIjtJpySIIBA0CAUxWj9y54ntC3edGcfU7LDv9X0+fu/z+RLW+NAa+0cRoBiBJUUgoekHiBEA8R4wqhlUkStiAk+A8AFMb5jQrcihAbfFvSiApnVWzGGmkWE2gbHDlWHCO4K4vQ6lHbLcMOGk4wiQTOlHTeYOMKpcOS4QIqJPLKhRaQ722ulbAhiG4Z38aqoMDts6/vFKes9gJlA1M++ydUKk+7wiJklSplBmAUBrd3dZdmTsGTNqrQwS8BoekuLNobfz71Op9LZZEwaAQ5Z6RAM+r/AXQuQBGIZRMpkxHzLzMRsjLbFI8BoRmcmUUQvTrIGAEMIzKF+5+DKnk2zTFTZx3Qa+11fuqZMk6dvv+zyAhJa+B8YZ61DSEyUaOt7efqdqem6mkxn++XJE1F9C4nwkIg2rrXoPg+st7RC6FDl8dgFAUjNOmZy9b0M+xaVlW+PhC5+TKf2FXXpANFize/u+oaHhjZnZzEeAN1jZE+Q5HZOlBz9b+NdRNf05Mx+2Dj0exeVwXSKl18PkHse2EuJcPBK8q2p6FzMHbFLZH5dDR/IAElp6DIxN1hEQajwaVFQtrTIj5gQgSNyMycHLqqa3MPNVmzSMK3K48v8CcEoBQI+VaOjEqqbAqQgBmkbp+i2rWoS5fKxpG+YAVn0QET31ecVJ20GUg8iN4rmR8T4wH1zZUYxXns2V/mggMJU3wKyc5JbRlwwnTDYv2bbcUpYRKO0rF3FXy2i+w0Sr4QdlO/92HYMwKogaY5FQn91DXH1IsjzdwEATg3c6DaE/dyv1ISl0dqPt1v6smQ0QeO8/+5K5evEyhBZNwTJsu1ItAhQj8B3ljoowKP4aPQAAAABJRU5ErkJggg==)
            center no-repeat;
          background-size: cover;
        }
        .el-icon-view:before {
          content: "";
          font-size: 16px;
          visibility: hidden;
        }
      }
      .zhuce {
        width: 304px;
        height: 42px;
        background: #1077ff;
        border-radius: 4px;
        color: #fff;
        font-size: 15px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #ffffff;

        &.unready {
          background: rgba(233, 233, 233, 1);
          color: rgba(199, 199, 199, 1);
          border: none;
          cursor: not-allowed;
        }
      }

      .reset_pwd {
        width: 304px;
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #8a8e96;
        line-height: 19px;
        margin: 0 auto;
        margin-bottom: 20px;
        text-align: right;
        margin-bottom: 50px;
        span {
          font-size: 13px;
        }
        span.s2 {
          margin-left: 8px;
          color: rgba(16, 119, 255, 1);
          font-size: 13px;
          cursor: pointer;
        }
      }

      .login_rightnow {
        width: 304px;
        margin: 0 auto;
        height: 42px;
        font-size: 13px;
        font-weight: 500;
        color: #8a8e96;
        line-height: 27px;
        text-align: left;
        margin-bottom: 12px;
        .login {
          color: rgba(16, 119, 255, 1);
          cursor: pointer;
        }
      }
    }

    .done {
      img {
        display: block;
        width: 133px;
        height: 133px;
        margin: 0 auto;
        margin-top: 64px;
        margin-bottom: 32px;
      }
      .tip1 {
        height: 35px;
        font-size: 24px;
        font-weight: bold;
        color: #1077ff;
        line-height: 35px;
        text-align: center;
        margin-bottom: 21px;
      }
      .tip2 {
        font-size: 19px;
        font-weight: 500;
        color: #8a8e96;
        line-height: 29px;
        text-align: center;
        margin-bottom: 93px;
      }
      .btn {
        cursor: pointer;
        margin: 0 auto;
        width: 304px;
        height: 59px;
        line-height: 59px;
        background: #1077ff;
        border-radius: 5px;
        text-align: center;
        font-size: 21px;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .el-form-item__error {
      width: 298px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      font-size: 13px;
      color: #ff0000;
      line-height: 14px;
      word-break: break-word;
    }

    .pass .el-input__validateIcon {
      display: none;
    }
    // .pass input[type="text"]+.el-input__clear {
    //   background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAETUlEQVRYR8WWf0yUdRzH35/7wQkG4k4B0S3LK5ory2ximpEjMHZw/qiw/mjT5jqO/pBjcKt/EusPGxCHc+O8VtlWWwH+QDoSMWbUIK3RtGWUoRWFmEpaFHLcj0/7Hnf2cDwP91jdfP68+zzP5/V9f35834Sb/NBNzo9JAMw8A8CLANYCSATQA2A7EV2MF+h1gHDy4wDujUo2DMBMRCfiASEF2AHgpeHhK+jo7ILXO47Vq5Zj0e0LRd7fhSrxgJACiNNnv9fUgl8Gh0KHJSIUFjyKu7JMcYOQApwCsOTtd5pw6bJQfeKRQjDzn61tR9u+7z87HwwTg1JDMeCrIPSD6UsmNDnstm615ZICuACUnD33Iw62toOZZSG8Xi+aD3gwdGGaviT0ETRv6GB4y27fcnU6GClAGoBvABi//a4fnsMf/TeICfWGWEPPOraVtCtBRI9hNoAjAGbFghj3+QIfeDq6z/008BuBTMx8t2ISIldKkqbCarWORsdMWURXRkYenmkwdOr1el0sCOl01Nc3ZI0H4QaQIwdCRN0pSZr8aIhJAG63W//HaPBQRvrcgic3FsJgMCAWRCAQvNZ78lT58mVLRXLU7nI5OIhXZSGA9pSZWovVavVdb3JpYLWz4X0wNonf5mWkQS2EaMzWtqO9538+v7GszDpQU+fax+DHZUtCaHTYS5+aAlDrdK8PcuCg9KUbhWjxdPSlG5OXnD49MGt0fPQHgJPlIDSk3VBht7ZMjHD4qXG6jjHzI9EvCIhNT6zz6fU6faxyCCW6P+utyl2zakeN09XIzMUK/fBxpd22ZhJAtbPhMhhGuRey7jS9azHnFamZDr8/4NXptDm19XsKmHm7QhmGHfbSOaoBCJqaCrt1v9/v79LpdIZYSojp8LR3Nvf1ndmqGkCpBOGF7HGU24qOdfW88GD2/TvVTIfP5/c17jukl9uYRDS1BHJN+A89jcEw47bK0s0Xm/d7ei2FefepgVBa27JNKJJJx3CqdPSho9xm3r37zcyMzLQDRea87H8FoTSGImFkETFzgUL3VlWUlbxCRMHjX5x87oGl99RrtZrEWD0RUeLCr5cOpyRp1ikuIpG0rqkp0T84fATMqxW2WQ+0ZK3cZvuamVXfHT6fz/+X15s7Ozn5E+l3ZU2p2+1OGhnl6iAHn1e6YBC6cunMwlsXpFrMax9KSNBrYykh56ymdcXVde58UGAvGJmKIDe4tgEIt7M4YnRj2nKnc29qgMe2MLCVwYuVQNSs7Q2WxyIecw8R2SYtoulOGPnvtV2vrwwEA8UEXiZnye4wLRq0mPOEg75Frhxz5xix+ZnQdv6KiELuO6YCasCkMdM15oL58/B08XoRfoKIVsQFQHxUCiE85qfdn8NgSEB+bg6Mxtki5GUiCt0T/7sCETXCEG3CY0apKNz3CiIaiytAWIl0AFUAVgK4FvabOyPJ4w6gpn/iVgI1yUXM3wHsfj8AykWSAAAAAElFTkSuQmCC)
    //     center no-repeat;
    //   background-size: cover;
    // }
    // .pass input[type="password"]+.el-input__clear {
    //   background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACuUlEQVRYR+2WTUgUYRjH/8+7ibnSJuTJToXQBx2i8FAZ1WUjIiuErUuUYszuVriz7M41oUvsbM6KtMNE6aVDilBRlHbJIjtJpySIIBA0CAUxWj9y54ntC3edGcfU7LDv9X0+fu/z+RLW+NAa+0cRoBiBJUUgoekHiBEA8R4wqhlUkStiAk+A8AFMb5jQrcihAbfFvSiApnVWzGGmkWE2gbHDlWHCO4K4vQ6lHbLcMOGk4wiQTOlHTeYOMKpcOS4QIqJPLKhRaQ722ulbAhiG4Z38aqoMDts6/vFKes9gJlA1M++ydUKk+7wiJklSplBmAUBrd3dZdmTsGTNqrQwS8BoekuLNobfz71Op9LZZEwaAQ5Z6RAM+r/AXQuQBGIZRMpkxHzLzMRsjLbFI8BoRmcmUUQvTrIGAEMIzKF+5+DKnk2zTFTZx3Qa+11fuqZMk6dvv+zyAhJa+B8YZ61DSEyUaOt7efqdqem6mkxn++XJE1F9C4nwkIg2rrXoPg+st7RC6FDl8dgFAUjNOmZy9b0M+xaVlW+PhC5+TKf2FXXpANFize/u+oaHhjZnZzEeAN1jZE+Q5HZOlBz9b+NdRNf05Mx+2Dj0exeVwXSKl18PkHse2EuJcPBK8q2p6FzMHbFLZH5dDR/IAElp6DIxN1hEQajwaVFQtrTIj5gQgSNyMycHLqqa3MPNVmzSMK3K48v8CcEoBQI+VaOjEqqbAqQgBmkbp+i2rWoS5fKxpG+YAVn0QET31ecVJ20GUg8iN4rmR8T4wH1zZUYxXns2V/mggMJU3wKyc5JbRlwwnTDYv2bbcUpYRKO0rF3FXy2i+w0Sr4QdlO/92HYMwKogaY5FQn91DXH1IsjzdwEATg3c6DaE/dyv1ISl0dqPt1v6smQ0QeO8/+5K5evEyhBZNwTJsu1ItAhQj8B3ljoowKP4aPQAAAABJRU5ErkJggg==)
    //     center no-repeat;
    //   background-size: cover;
    // }
  }
}
</style>
